import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import './CookieConsentBar.css';

const CookieConsentBarContent = ({ accepted, onAccept }) => (
  !accepted && (
    <div className="cookie-consent-bar">
      We use cookies to improve your user experience.
      By using this site you agree to our <Link to="/cookie-policy">cookie policy</Link>.
      <button onClick={onAccept}>I consent</button>
    </div>
  )
);

CookieConsentBarContent.PropTypes = {
  accepted: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default CookieConsentBarContent;


// WEBPACK FOOTER //
// ./src/components/CookieConsentBar/CookieConsentBarContent.jsx